<template>
    <Head title="Update Page" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Update Page - {{ page.name }}
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form @submit.prevent="submit" class="w-full">
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Name</admin-app-label>
                        <input-basic
                            placeholder="Name"
                            v-model="form.name"
                            :error="errors['name']"
                        />
                        <input-error v-if="errors['name']">
                            {{ errors.name }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            v-model="form.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['content']">
                            {{ errors.content }}
                        </input-error>
                    </div>
                    <div class="grid md:grid-cols-2 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>CTA Text</admin-app-label>
                            <input-basic
                                placeholder="CTA Text"
                                v-model="form.cta_text"
                                :error="errors['cta_text']"
                            />
                            <input-error v-if="errors['name']">
                                {{ errors.cta_text }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>CTA Link</admin-app-label>
                            <input-basic
                                placeholder="CTA Link"
                                v-model="form.cta_link"
                                :error="errors['cta_link']"
                            />
                            <input-error v-if="errors['cta_link']">
                                {{ errors.cta_link }}
                            </input-error>
                        </div>
                    </div>
                    <div class="grid md:grid-cols-3 gap-4">
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Season</admin-app-label>
                            <input-select
                                placeholder="Season"
                                :options="seasons"
                                v-model="form.season"
                                :error="errors['season']"
                                label="name"
                            />
                            <input-error v-if="errors['season']">
                                {{ errors.season }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Vehicle Type</admin-app-label>
                            <input-select
                                placeholder="Vehicle Type"
                                :options="vehicleTypes"
                                v-model="form.vehicle_type"
                                :error="errors['vehicle_type']"
                                label="name"
                            />
                            <input-error v-if="errors['vehicle_type']">
                                {{ errors.vehicle_type }}
                            </input-error>
                        </div>
                        <div class="mb-6 md:mb-4">
                            <admin-app-label>Specialist Type</admin-app-label>
                            <input-select
                                placeholder="Specialist Type"
                                :options="specialistTypes"
                                v-model="form.specialist"
                                :error="errors['specialist']"
                                label="name"
                            />
                            <input-error v-if="errors['specialist']">
                                {{ errors.specialist }}
                            </input-error>
                        </div>
                    </div>

                    <add-videos v-model="form.videos" :errors="errors"></add-videos>

                    <seo-tags v-model="form.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Update</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import BreezeAuthenticatedLayout from '@/Layouts/Admin/Authenticated.vue'
import {Head} from "@inertiajs/inertia-vue3";
import Label from "@/Components/Label";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import SeoTags from "@/Components/Admin/Forms/SeoTags";
import AddVideos from "@/Components/Admin/Forms/AddVideos";

export default {
    name: "Edit",
    components: {
        AddVideos,
        SeoTags,
        BreadCrumbs,
        InputWysiwyg,
        ImageUpload,
        InputSelect,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        FontAwesomeIcon,
        BreezeAuthenticatedLayout,
        Head,
        InputError
    },
    props: {
        errors: Object,
        page: Object,
        seasons: Object,
        vehicleTypes: Object,
        specialistTypes: Object,
    },
    data() {
        return {
            navItems: [
                { title: 'Pages', path: '/admin/pages' },
            ],
            form: this.$inertia.form({
                ...this.page,
                _method: "put",
            }),
        }
    },
    mounted() {
        var valueToPush = { };
        valueToPush.title = '#'+ this.page.id;
        valueToPush.path = "/admin/pages/"+this.page.id+"/edit";

        this.navItems.push(valueToPush);
    },
    methods: {
        submit()
        {
            this.form.post(`/admin/pages/${this.page.id}`);
        }
    }
}
</script>

<style scoped>

</style>
